import { render, staticRenderFns } from "./zpin.vue?vue&type=template&id=71512c3e&scoped=true"
import script from "./zpin.vue?vue&type=script&lang=js"
export * from "./zpin.vue?vue&type=script&lang=js"
import style0 from "./zpin.vue?vue&type=style&index=0&id=71512c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71512c3e",
  null
  
)

export default component.exports